<template>
    
    <v-lazy :value="eager">
        
        <v-img v-show="imagerurl && thumburl"
               :key="pdfThumbnail ? `${pdfPreviewKey}:R${pdfThumbnailRevision}` : img"
               contain
               :aspect-ratio="aspectRatio"
               @click.native.stop="showPdf"
               @error="imageError"
               @load="preloadPdf"
               @mouseenter.native="preloadPdf"
               class="m-2"
               :style="{cursor: !missing? pdfShow?'zoom-in':'pointer':''}"
               ref="vImg"
               :lazy-src="thumburl"
               :src="imagerurl"
               :eager="eager"
        >
            <template v-slot:placeholder>
                <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                >
                    <v-progress-circular v-if="!missing && !thumbnailUnavailable"
                                         aria-label="Caricamento anteprima disegno"
                                         indeterminate
                                         :size="height/3"
                                         color="grey lighten-2"
                    >
                    </v-progress-circular>
                    <v-icon v-else
                            :size="height/2"
                            color="grey" title="Anteprima non disponibile">mdi-image-broken
                    </v-icon>
                </v-row>
            </template>
            <slot name="statusicon">
            
            </slot>
            <v-icon v-if="multipagina"
                    :style="{'position': 'absolute','color': 'red','right': `10px`,'bottom':'10px','text-shadow':  '1px 1px 2px black'}"
                    title="Multipagina">mdi-file-document-multiple
            </v-icon>
        
        </v-img>
        <!--
        <v-img v-else>
            <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
            >
                <v-progress-circular
                    indeterminate
                    :size="height/3"
                    color="grey lighten-2"
                >
                </v-progress-circular>
            </v-row>
        </v-img>
    --->
    </v-lazy>

</template>
<script>
    
    import Thumbor from "thumbor";
    import _ from "lodash";
    import {bus} from "@/main";
    import {drawingRequestWidth} from "./drawingImageSizing.mjs";
    import drawingS3Preview from "./drawingS3Preview.mjs";
    import drawingPdfPreview from "./drawingPdfPreview.mjs";
    import {hasDrawingName} from "./drawingName.mjs";
    
    export default {
        name: 'btDisegno',
        mixins: [drawingS3Preview, drawingPdfPreview],
        created() { bus.$on('pdf-preview-updated', this.acceptPdfPreview); },
        props: {
            prefetchPdf: {type: Boolean, default: false},
            articolo: {type: String, required: true},
            disegno: {type: String, required: true},
            minio: {type: String, required: false},
            width: {type: Number, default: 100},
            aspectRatio: {type: Number, default: undefined},
            icon: {type: Boolean, default: false},
            multipagina: {type: Boolean, default: false},
            pdfShow: {type: Boolean, default: true},
            hidemissing: {type: Boolean, default: false},
            autoGenerate: {type: Boolean, default: true},
            s3First: {type: Boolean, default: false},
            thumbnailSize: {type: Number, default: 480},
            eager: {type: Boolean, default: false},
        },
        data() {
            return {
                //realwidth: undefined,
                metadata: undefined,
                refreshtimer: undefined,
                minio_url: undefined,
                missing: false,
                thumbnailUnavailable: false,
                checkingThumbnail: false,
                thumbnailRequestEpoch: 0
            }
        },
        computed: {
            height() {
                let w = this.width < this.$vuetify.breakpoint.width ? this.width : this.$vuetify.breakpoint.width - 50
                return w * 0.7;
            },
            requestWidth() {
                return drawingRequestWidth(
                    this.width,
                    this.$vuetify.breakpoint.width
                );
            },
            imagerurl() {
                if (!this.img) return '';
                if (this.pdfThumbnail) return this.pdfThumbnail;
                if (this.s3Thumbnail) return this.s3Thumbnail;
                if (this.s3First && (this.s3PreviewAttempted !== this.s3PreviewKey || this.s3PreviewRequest)) return '';
                let thumbor = new Thumbor(this.$ThumborKey, this.$ThumborUrl);
                return thumbor.setImagePath(this.img).fitIn(`${this.requestWidth}`, "0").buildUrl()
            },
            thumburl() {
                if (!this.img) return '';
                if (this.pdfThumbnail) return this.pdfThumbnail;
                if (this.s3Thumbnail) return this.s3Thumbnail;
                let thumbor = new Thumbor(this.$ThumborKey, this.$ThumborUrl);
                return thumbor.setImagePath(this.img).fitIn("50", "35").buildUrl();
            },
            img() {
                if (!hasDrawingName(this.disegno) || !this.articolo?.trim()) {
                    return '';
                }

                let originalDisegno = String(this.disegno);
                let baseDisegno = originalDisegno.includes('.')
                    ? originalDisegno.split('.').slice(0, -1).join('.')
                    : originalDisegno;
                const stem = _.kebabCase(_.deburr(baseDisegno));
                if (!stem) return '';
                let disegno = stem + '.jpg'
                return `${this.articolo[0].toLowerCase()}/${this.articolo.toLowerCase()}/${disegno}`;
            }
        },
        watch: {
            img() {
                this.thumbnailRequestEpoch++;
                this.checkingThumbnail = false;
                this.metadata = undefined;
                this.thumbnailUnavailable = false;
                clearTimeout(this.refreshtimer);
                this.setMissingState(false);
            }
        },
        methods: {
            preloadPdf() {
                if (!hasDrawingName(this.disegno)) return;
                this.$emit('thumbnail-loaded', this.$refs.vImg?.image);
                if (this.prefetchPdf && this.pdfShow && !this.missing) {
                    const item = { articolo: this.articolo, disegno: this.disegno, minio: this.minio_url };
                    const preload = () => bus.$emit('prefetch-pdf', item);
                    if (window.requestIdleCallback) {
                        if (this._pdfIdleId !== undefined) window.cancelIdleCallback(this._pdfIdleId);
                        this._pdfIdleId = window.requestIdleCallback(preload, { timeout: 1500 });
                    } else {
                        window.clearTimeout(this._pdfIdleTimer);
                        this._pdfIdleTimer = window.setTimeout(preload, 100);
                    }
                }
            },
            setMissingState(value) {
                this.missing = value
                this.$emit('missing-change', value)
            },
            imageError: async function (err) {
                if (!hasDrawingName(this.disegno) || !this.autoGenerate || this.s3Thumbnail) {
                    this.thumbnailUnavailable = true;
                    return;
                }
                const key = this.s3PreviewKey;
                // The PDF may already be in S3 while the old shared JPEG is missing.
                if (await this.loadS3Preview()) return;
                if (key !== this.s3PreviewKey || this.s3PreviewDisposed) return;
                console.log(`Rebuild missing image ${err}`)
                this.check_thumb()
            },
            showPdf: function () {
                if (this.pdfShow && !this.missing && hasDrawingName(this.disegno)) {
                    bus.$emit('show-pdf', {
                        'articolo': this.articolo,
                        'disegno': this.disegno,
                        'minio': this.minio_url
                    })
                }
            },
            async check_thumb() {
                if (this.checkingThumbnail || this.missing || !this.articolo || !hasDrawingName(this.disegno)) return;

                this.checkingThumbnail = true;
                const epoch = ++this.thumbnailRequestEpoch;
                const imagePath = this.img;
                const pdf = `${this.articolo[0]}/${this.articolo}/${this.disegno}`;
                const isCurrent = () => !this._isBeingDestroyed && !this._isDestroyed
                    && this.thumbnailRequestEpoch === epoch && this.img === imagePath;
                const thumbor = new Thumbor(this.$ThumborKey, this.$ThumborUrl);
                const metaurl = thumbor.metaDataOnly(true).setImagePath(imagePath).buildUrl();
                const ts = this.$moment().toISOString();

                try {
                    const response = await this.$work.thumbmeta(metaurl, {ts});
                    if (!isCurrent()) return;
                    this.metadata = response.data;
                    this.setMissingState(false);
                    console.log(`Metadata ${response.data} loaded`);
                } catch (metadataError) {
                    if (!isCurrent()) return;
                    console.log(`Error loading metadata ${metadataError}`);
                    clearTimeout(this.refreshtimer);
                    this.refreshtimer = setTimeout(() => {
                        if (isCurrent() && this.$refs.vImg) this.$refs.vImg.loadImage();
                    }, 10000);

                    try {
                        await this.$work.post('/arts/generajpeg/', {
                            pdf,
                            img: imagePath
                        }, true);
                        if (!isCurrent()) return;
                        console.log(`Image ${this.img} generated`);
                    } catch (error) {
                        if (!isCurrent()) return;
                        if (error.response?.status === 404) {
                            clearTimeout(this.refreshtimer);
                            this.setMissingState(true);
                            console.log(`Image ${this.img} not found`);
                        } else {
                            console.log(`Error generating image ${error}`);
                        }
                    }
                } finally {
                    if (isCurrent()) this.checkingThumbnail = false;
                }
            }
        },
        mounted() {
            if (this.prefetchPdf && this.pdfShow && hasDrawingName(this.disegno)) {
                bus.$emit('prefetch-pdf', { articolo: this.articolo, disegno: this.disegno, minio: this.minio_url });
            }
            if (this.s3First) this.loadS3Preview();
        },
        beforeDestroy() {
            bus.$off('pdf-preview-updated', this.acceptPdfPreview);
            this.thumbnailRequestEpoch++;
            if (this._pdfIdleId !== undefined) window.cancelIdleCallback(this._pdfIdleId);
            window.clearTimeout(this._pdfIdleTimer);
            this.refreshtimer && clearTimeout(this.refreshtimer)
        }
    }
</script>

<style>
.multipagina {
    position: absolute;
    bottom: 10px;
    right: 10px;
}
</style>
